import { createStore } from 'zustand'
import { StatsBoxStore } from './types'

export const createStatsBoxStore = () => {
  return createStore<StatsBoxStore>()((set, get) => ({
    viewed: false,
    setViewed: (viewed) => set({ viewed }),
  }))
}
